import React, { useState, useEffect } from "react";
import cloud_connectivity_icon from "../images/icons/connect_cloud_icon.svg";
import axios from "axios";
import { API_BASE_URL, QBO_APP_BASE_URL } from "../utils/constants";
import { useParams, useHistory} from "react-router-dom";
import AppFooter from "../Components/Footer";
import { openNotification} from "../utils/helpers";

function ConnectionStatus(prop) {
  let history = useHistory();
  const [company, setCompany] = useState(null);
  const params = useParams();

  useEffect(() => {
    getCompanyDetails();
  }, []);

  const getCompanyDetails = () => {
    axios
      .get(API_BASE_URL + "/api/company/details?companyId=" + params.companyId)
      .then(async (res) => {
        const company = await res.data;
        setCompany(company.data);
      })
      .catch((err) => {
        console.log("err in catch of getCompanyDetails", err);
        if(err.response?.status === 401 ){
          HandleUnauthorizedUserFlow(err);
          }

          //network error 
          if(err.message){
            openNotification(
              "topRight",
              "Unauthorized!",
              err.message,
              "error"
            );   
            return history.push('/unAuthorizedPage');
          } 
      });
  };

  function HandleUnauthorizedUserFlow(err){
      openNotification(
        "topRight",
        "Unauthorized!",
        err.response.data.message,
        "error"
      );         
     
    return history.push("/unAuthorizedUser");
}


  function disconnectQBO(e) {
    window.open(
      QBO_APP_BASE_URL + "/revoketoken.php?companyId=" + params.companyId,
      "_self"
    );
  }

  return (
    <div className="flex flex-col h-screen">
      <div className="flex-1">
        {!company && (
          <div className="w-full flex justify-center">loading...</div>
        )}
        {company && (
          <div className=" bg-white w-full h-full flex items-center justify-center">
            <div className="self-center content-center ">
              <div className="w-full flex justify-center items-center">
                <div className="">
                  <div className="flex justify-center">
                    <img src={require("../images/icons/tick.png")} />
                  </div>
                  <div className="flex justify-start font-bold font-raleway text-heading text-black_text_dark mt-6">
                    Welcome to the QuickBooks Connection Dashboard.
                  </div>
                  <div className="flex justify-center font-normal font-raleway text-sub_heading text-gray_text_light mb-2 mt-3.5">
                    <span className="pl-2">
                      You are currently connected to{" "}
                    </span>
                    <span className="px-1 font-bold">
                      {company.qbo_company_name}
                    </span>
                  </div>
                  <div className="flex justify-center">
                    <button
                      className="text-sky-400 underline"
                      onClick={(e) => {
                        disconnectQBO(e);
                      }}
                    >
                      Disconnect from QuickBooks
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        )}
      </div>
      <div className="flex-none">
          <AppFooter/>
      </div>
    </div>
  );
}

export default ConnectionStatus;
